import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase'; // Asegúrate que la ruta a tu config de firebase sea correcta
import CategoriaCard from '../components/CategoriaCard';
import '../styles/RecomendacionesPage.css'; // Crearemos este archivo para estilos

function RecomendacionesPage() {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategorias = async () => {
      setLoading(true);
      setError(null);
      try {
        const categoriasCollection = collection(db, 'recomendaciones');
        // Ordenar por el campo 'orden' si existe, si no, por 'nombre'
        const q = query(categoriasCollection, orderBy('orden', 'asc'), orderBy('nombre', 'asc'));
        const querySnapshot = await getDocs(q);
        
        const categoriasData = querySnapshot.docs.map(doc => {
          const data = doc.data();
          // Check if 'nombre' exists and provide a fallback
          if (!data.nombre) {
            console.warn(`Category with ID ${doc.id} is missing 'nombre' field`);
            data.nombre = `Categoría ${doc.id}`;
          }
          return {
          id: doc.id,
            ...data
          };
        });
        
        console.log("Fetched categories:", categoriasData);
        setCategorias(categoriasData);
      } catch (err) {
        console.error("Error fetching categorias:", err);
        setError('No se pudieron cargar las categorías. Inténtalo de nuevo más tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchCategorias();
  }, []);

  return (
    <div className="recomendaciones-page">
      <h1>Recomendaciones</h1>
      <p>Descubre los mejores lugares y actividades que Futaleufú tiene para ofrecer.</p>

      {loading && <p>Cargando categorías...</p>}
      {error && <p className="error-message">{error}</p>}

      {!loading && !error && (
        <div className="categorias-grid">
          {categorias.length > 0 ? (
            categorias.map(categoria => {
              console.log("Rendering categoria:", categoria); // Log each category for debugging
              const imgUrl = categoria.imagenes && categoria.imagenes.length > 0 
                ? categoria.imagenes[0] 
                : undefined;
                
              return (
              <CategoriaCard
                key={categoria.id}
                id={categoria.id}
                nombre={categoria.nombre}
                  imagenUrl={imgUrl}
              />
              );
            })
          ) : (
            <p>No hay recomendaciones disponibles por el momento.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default RecomendacionesPage; 